import * as yup from 'yup';
import { MAX_TOTAL_ATTACHMENTS } from './constants';

const validationSchema = yup
  .object({
    name: yup.string().required('Template Name is required'),

    subjectGr: yup
      .string()
      .nullable()
      .test('subjectGr-required', 'Subject (GR) is required', (value, ctx) => {
        const body = ctx.parent?.bodyGr;
        if (body && !value?.trim())
          return ctx.createError({ message: 'Subject (GR) is required' });
        return true;
      }),

    bodyGr: yup
      .string()
      .nullable()
      .test('bodyGr-required', 'Body (GR) is required', (value, ctx) => {
        const subject = ctx.parent?.subjectGr;
        if (subject && !value?.trim())
          return ctx.createError({ message: 'Body (GR) is required' });
        return true;
      }),

    subjectEn: yup
      .string()
      .nullable()
      .test('subjectEn-required', 'Subject (EN) is required', (value, ctx) => {
        const body = ctx.parent?.bodyEn;
        if (body && !value?.trim())
          return ctx.createError({ message: 'Subject (EN) is required' });
        return true;
      }),

    bodyEn: yup
      .string()
      .nullable()
      .test('bodyEn-required', 'Body (EN) is required', (value, ctx) => {
        const subject = ctx.parent?.subjectEn;
        if (subject && !value?.trim())
          return ctx.createError({ message: 'Body (EN) is required' });
        return true;
      }),

    attachmentGr: yup.array().nullable(),
    attachmentEn: yup.array().nullable(),
  })
  .test(
    'at-least-one-language',
    'You must complete at least one language (Subject & Body)',
    (values) => {
      const grComplete = values?.subjectGr?.trim() && values?.bodyGr?.trim();
      const enComplete = values?.subjectEn?.trim() && values?.bodyEn?.trim();
      return grComplete || enComplete;
    }
  )
  .test(
    'max-total-attachments',
    `You can upload up to ${MAX_TOTAL_ATTACHMENTS} attachments in total`,
    (values) => {
      const total =
        (values?.attachmentGr?.length || 0) +
        (values?.attachmentEn?.length || 0);
      return total <= MAX_TOTAL_ATTACHMENTS;
    }
  );

export default validationSchema;
